// Verzonnen cijfers voor het animatielab, zodat je de animaties kunt bekijken
// zonder in te loggen en zonder op een echte verkoop te wachten.
//
// De namen komen terug in registry.js (demo.name): de animatie "rij oplichten"
// zoekt de rij op via data-name, dus die moeten hier bestaan.

export const mockData = {
  teamTarget: { amount: 85000, text: "Karten + BBQ" },
  amount: 63450, // gelijk aan de som van de ranglijst hieronder
  scoredTowardsTarget: 63450,

  // Ernst, Bobbie en Bert staan alle drie op het podium: dat zijn de drie
  // verkopers van het betalingsklavier, zie labData.js.
  rankList: [
    { name: "Ernst", totalPrice: 18400 },
    { name: "Bobbie", totalPrice: 15250 },
    { name: "Bert", totalPrice: 11900 },
    { name: "Ernie", totalPrice: 9500 },
    { name: "Hans", totalPrice: 4600 },
    { name: "Grietje", totalPrice: 2400 },
    { name: "Johan Derksen", totalPrice: 1400 },
  ],

  soldServices: [
    { name: "Managed Cloud Backup", totalPrice: 14300 },
    { name: "Microsoft 365 Business", totalPrice: 11750 },
    { name: "Werkplekbeheer", totalPrice: 9800 },
    { name: "Firewall as a Service", totalPrice: 7450 },
    { name: "VoIP telefonie", totalPrice: 5900 },
    { name: "Hosting & domeinen", totalPrice: 4200 },
    { name: "Security awareness", totalPrice: 3100 },
    { name: "Hardware levering", totalPrice: 2750 },
  ],

  yearRankList: [
    { date: "09-2026", name: "Ernst", totalPrice: 18400 },
    { date: "08-2026", name: "Bobbie", totalPrice: 21100 },
    { date: "07-2026", name: "Ernie", totalPrice: 17600 },
    { date: "06-2026", name: "Bobbie", totalPrice: 19850 },
    { date: "05-2026", name: "Ernst", totalPrice: 16400 },
    { date: "04-2026", name: "Bert", totalPrice: 15200 },
    { date: "03-2026", name: "Ernie", totalPrice: 14750 },
    { date: "02-2026", name: "Bobbie", totalPrice: 13900 },
    { date: "01-2026", name: "Hans", totalPrice: 12300 },
  ],

  bestSeller: { name: "Bobbie" },
  deals: { totalDeals: 34, totalPrice: 58400, averagePrice: 1718 },
  existantDeals: { totalDeals: 12, totalPrice: 19600, averagePrice: 1633 },
};
